/** @type {import('tailwindcss').Config} */
const config = {
  plugins: {
    '@tailwindcss/postcss': {}
  }
}

export default config
